function toPositiveMessagingId(value) {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

function createMessagesTargetParams({ conversationId = null, businessId = null } = {}) {
  const params = new URLSearchParams();

  const normalizedConversationId = toPositiveMessagingId(conversationId);
  const normalizedBusinessId = toPositiveMessagingId(businessId);

  if (normalizedConversationId) {
    params.set("conversation", String(normalizedConversationId));
  }

  if (normalizedBusinessId) {
    params.set("business", String(normalizedBusinessId));
  }

  return params;
}

function buildMessagesRoute(target = {}) {
  const params = createMessagesTargetParams(target);
  const queryString = params.toString();
  return queryString ? `/messages?${queryString}` : "/messages";
}

async function openShopperBusinessConversation({ businessId, startConversation } = {}) {
  const normalizedBusinessId = toPositiveMessagingId(businessId);
  if (!normalizedBusinessId || typeof startConversation !== "function") return null;

  const conversation = await startConversation(normalizedBusinessId, {
    openWidget: true,
    openEmbedded: false,
  });

  const resolvedConversationId = toPositiveMessagingId(conversation?.id);
  if (!resolvedConversationId) return null;

  return conversation;
}

export {
  buildMessagesRoute,
  createMessagesTargetParams,
  openShopperBusinessConversation,
  toPositiveMessagingId,
};